import React from "react";
import { useSelector, useDispatch } from "react-redux";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { actionCreators } from "../redux/serviceBookingsSagas";
import { selectChartControlsDisabled } from "../redux/serviceBookingsSelectors";

export const GroupByFilter = () => {
  const dispatch = useDispatch();

  const options = useSelector((state) => state.serviceBookings.filters.group_by);
  const selectedGroupBy = useSelector((state) => state.serviceBookings.selectedFilters.group_by);
  // Refetches the heatmap without the Update button, so it must be inert whenever Update is.
  const disabled = useSelector(selectChartControlsDisabled);

  const onSelectChange = (data) => {
    if (data.id === selectedGroupBy.id) return;
    dispatch(actionCreators.updateGroupBy(data));
  };

  return (
    <div className="group-by-filter" style={disabled ? { cursor: "not-allowed" } : undefined}>
      <div {...(disabled ? { inert: "" } : {})}>
        <MultiSelectDropdown
          options={options}
          selectedFilters={selectedGroupBy}
          placeholder="Select Group by"
          numberDisplayed={0}
          onSelectChange={onSelectChange}
        />
      </div>
    </div>
  );
};
